<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Edit Record</h3>
        <form name="form1" @submit.prevent="save()">
          <table>
            <tr>
              <td>
                Sport:
              </td>
              <td>
                <select v-model="sport">
                  <option v-for="s in sports" :key="s.id" :value="s">
                    {{ s.sport }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Pick:
              </td>
              <td>
                <input
                  v-model="pick"
                  type="text"
                  name="pick"
                  size="33"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Side:
              </td>
              <td>
                <input
                  v-model="side"
                  type="text"
                  name="side"
                  size="10"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Risk:
              </td>
              <td>
                <input
                  v-model="risk"
                  type="text"
                  name="risk"
                  size="5"
                  maxlength="10"
                />
              </td>
            </tr>
            <tr>
              <td>
                Result:
              </td>
              <td>
                <input
                  v-model="result"
                  type="text"
                  name="result"
                  size="3"
                  maxlength="1"
                />
              </td>
            </tr>
          </table>
          <p>
            <input type="submit" name="submit" value="Submit Record" />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import RecordRepository from "../../data/record.repository.js";
import _ from "lodash";
export default {
  data() {
    return {
      sports: this.$store.state.sports,
      id: "",
      pick: "",
      side: "",
      risk: "",
      result: "",
      sport: "",
    };
  },
  created() {
    if (this.$route.params.id) {
      RecordRepository.one(this.$route.params.id).then((record) => {
        this.id = record.record_id;
        this.pick = record.pick;
        this.side = record.side;
        this.risk = record.risk;
        this.result = record.result;
        this.sport = _.find(this.sports, ["id", record.sports_id]);
      });
    }
  },
  methods: {
    save() {
      const r = {
        record_id: this.id,
        pick: this.pick,
        side: this.side,
        risk: this.risk,
        result: this.result,
        sports_id: this.sport.id,
      };
      RecordRepository.save(r)
        .then((result) => {
          this.$root.$refs.toastr.s("Result saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// EditRecord.vue?cae5917c